import { IsIn, IsInt, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';
export class MerchantFilters {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  brandId?: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  costCentreId?: number;

  @IsOptional()
  @IsIn(['active', 'inactive'])
  status?: string;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  merchantGroupId?: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  merchantBusinessEntityId?: number;

  @IsOptional()
  @IsString()
  merchantGroupLink?: string;

  @IsOptional()
  @IsString()
  brandLink?: string;

  @IsOptional()
  @IsString()
  costCentreLink?: string;

  @IsOptional()
  @IsString()
  hidden?: string;
}